import { render, staticRenderFns } from "./ProductosTable.vue?vue&type=template&id=3ad91d7a"
import script from "./ProductosTable.vue?vue&type=script&lang=js"
export * from "./ProductosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports